import IStep from '../../lib/IStep';

export default class Step implements IStep {
  /**
   * Fired when the step is initialized
   */
  onInit() {
    // run business logic here when the step is initialized
  }
}
